<template>
  <div class="index">
    <Header :environment="environment" />
    <div class="index-con">
        <div  :class="['index-con-item',('color'+Math.ceil((index+1)/4))]" v-for="(item,index) in list" :key="index" @click="readyGo(item.url)" >
            <img :src="item.icon" alt="">
            <div>{{ item.name }}</div>
        </div>
    </div>
    
    
   
  </div>
</template>
  
  <script>
import Header from "../components/Header.vue";
export default {
  components: {
    Header,
  },
  data() {
    return {
      linKObjProd:[
        {name:'鼎函官网',url:'https://dinghanwang.com/#/',icon:require('../assets/img/home.png' )  },
        {name:'保函系统-客户端',url:'https://tb.dinghanwang.com/login',icon:require('../assets/img/people.png' )  },
        {name:'保函系统-管理端',url:'https://admin.dinghanwang.com/login',icon:require('../assets/img/shezhi.png' )  },
        {name:'销售管理系统',url:'https://mgt.dinghanwang.com',icon:require('../assets/img/pindao.png' )  },
        // {name:'竞采官网',url:'http://www.findbidding.cc ',icon:require('../assets/img/home.png' )  },
        // {name:'竞采保函系统-客户端',url:'http://tb.findbidding.cc',icon:require('../assets/img/people.png' )  },
        {name:'演示系统',url:'https://caigou.dinghanwang.com/',icon:require('../assets/img/eee.png' )  },
        // {name:'演示系统-竞采',url:'http://testgw.dinghanwang.com/',icon:require('../assets/img/file.png' )  },
        {name:'邮箱登录',url:'https://mail.hwmail.com.cn/mail/',icon:require('../assets/img/mail.png' )  },
        {name:'TAPD项目管理登录',url:'https://www.tapd.cn/my_dashboard',icon:require('../assets/img/lingdang.png' )  },
        {name:'华为云管理登录',url:'https://auth.huaweicloud.com/authui/login.html?id=nmgxykj#/login',icon:require('../assets/img/yun_1.png' )  },
        {name:'定时任务管理系统',url:'http://123.60.79.177:9090/xxl-job-admin/',icon:require('../assets/img/time.png' )  },
        {name:'datat',url:'http://elk.dinghanwang.com/',icon:require('../assets/img/images.png' )  },
        {name:'nexus中央存储库',url:'http://123.60.65.215:10082/',icon:require('../assets/img/dun.png' )  },
    ],
   /* linKObjDev:[
        {name:'鼎函官网',url:'http://testguanwang.dinghanwang.com/#/',icon:require('../assets/img/home.png' )  },
        {name:'保函系统-客户端',url:'https://open-test.dinghanwang.com',icon:require('../assets/img/people.png' )  },
        {name:'保函系统-管理端',url:'http://121.37.86.139:81/login',icon:require('../assets/img/shezhi.png' )  },
        {name:'销售管理系统',url:'http://salesmgt.dinghanwang.com',icon:require('../assets/img/pindao.png' )  },
        // {name:'竞采官网',url:'http://gwtest.findbidding.cc',icon:require('../assets/img/home.png' )  },
        // {name:'竞采保函系统-客户端',url:'http://bhtest.findbidding.cc/',icon:require('../assets/img/people.png' )  },
        {name:'演示系统',url:'https://dhcaigou.dinghanwang.com/',icon:require('../assets/img/eee.png' )  },
        // {name:'演示系统-竞采',url:'http://testgw.dinghanwang.com/',icon:require('../assets/img/file.png' )  },
        {name:'演示系统-安责',url:'http://testaz.dinghanwang.com',icon:require('../assets/img/file.png' )  },
        {name:'邮箱登录',url:'https://mail.hwmail.com.cn/mail/',icon:require('../assets/img/mail.png' )  },
        {name:'TAPD项目管理登录',url:'https://www.tapd.cn/my_dashboard',icon:require('../assets/img/lingdang.png' )  },
        {name:'华为云管理登录',url:'https://auth.huaweicloud.com/authui/login.html?id=nmgxykj#/login',icon:require('../assets/img/yun_1.png' )  },
        {name:'定时任务管理系统',url:'http://121.37.86.139:9090/xxl-job-admin/',icon:require('../assets/img/time.png' )  },
        {name:'elastic日志管理系统',url:'http://elk.dinghanwang.com/',icon:require('../assets/img/huifu.png' )  },
        {name:'nexus中央存储库',url:'http://123.60.65.215:10082/',icon:require('../assets/img/dun.png' )  },
        {name:'datat',url:'http://123.60.65.215:9092/',icon:require('../assets/img/images.png')},
        {name:'knife4j',url:'http://121.37.86.139:8081/doc.html#/home',icon:require('../assets/img/aite.png')},
        {name:'jenkins',url:'http://jenkins.dinghanwang.com',icon:require('../assets/img/aite.png')},
        {name:'GitLab',url:'https://gitlab.dinghanwang.com/',icon:require('../assets/img/aite.png')},
        {name:'rocketMQ',url:'https://test-rocketmq.dinghanwang.com/',icon:require('../assets/img/aite.png')},

      ],*/
      linKObjDev:[
        //{name:'鼎函官网',url:'http://testguanwang.dinghanwang.com/#/',icon:require('../assets/img/home.png' )  },
        {name:'保函系统-客户端',url:'https://dhdev-open.dinghanwang.com',icon:require('../assets/img/people.png' )  },
        {name:'保函系统-管理端',url:'https://dhdev-admin.dinghanwang.com/login',icon:require('../assets/img/shezhi.png' )  },
        {name:'销售管理系统',url:'https://dhdev-mgtdata.dinghanwang.com',icon:require('../assets/img/pindao.png' )  },
        // {name:'竞采官网',url:'http://gwtest.findbidding.cc',icon:require('../assets/img/home.png' )  },
        // {name:'竞采保函系统-客户端',url:'http://bhtest.findbidding.cc/',icon:require('../assets/img/people.png' )  },
        {name:'演示系统',url:'https://caigou.dinghanwang.com/',icon:require('../assets/img/eee.png' )  },
        // {name:'演示系统-竞采',url:'http://testgw.dinghanwang.com/',icon:require('../assets/img/file.png' )  },
        {name:'演示系统-安责',url:'http://testaz.dinghanwang.com',icon:require('../assets/img/file.png' )  },
        {name:'邮箱登录',url:'https://mail.hwmail.com.cn/mail/',icon:require('../assets/img/mail.png' )  },
        {name:'TAPD项目管理登录',url:'https://www.tapd.cn/my_dashboard',icon:require('../assets/img/lingdang.png' )  },
        {name:'华为云管理登录',url:'https://auth.huaweicloud.com/authui/login.html?id=nmgxykj#/login',icon:require('../assets/img/yun_1.png' )  },
        {name:'定时任务管理系统',url:'https://dhdev-xxljob.dinghanwang.com/xxl-job-admin/toLogin',icon:require('../assets/img/time.png' )  },
        //{name:'elastic日志管理系统',url:'http://elk.dinghanwang.com/',icon:require('../assets/img/huifu.png' )  },
        {name:'nexus中央存储库',url:'http://123.60.65.215:10082/',icon:require('../assets/img/dun.png' )  },
        {name:'datat',url:'http://123.60.65.215:9092/',icon:require('../assets/img/images.png')},
        //{name:'knife4j',url:'http://121.37.86.139:8081/doc.html#/home',icon:require('../assets/img/aite.png')},
        {name:'jenkins',url:'http://jenkins.dinghanwang.com',icon:require('../assets/img/aite.png')},
        {name:'GitLab',url:'https://dhgitlab.dinghanwang.com/',icon:require('../assets/img/aite.png')},
        {name:'rocketMQ',url:'https://dhdev-rocketmq.dinghanwang.com/',icon:require('../assets/img/aite.png')},

      ],
    linKObjTest:[
        {name:'鼎函官网',url:'https://dhtest-guanwang.dinghanwang.com/#/',icon:require('../assets/img/home.png' )  },
        {name:'保函系统-客户端',url:'https://dhtest-open.dinghanwang.com',icon:require('../assets/img/people.png' )  },
        {name:'保函系统-管理端',url:'https://dhtest-admin.dinghanwang.com',icon:require('../assets/img/shezhi.png' )  },
        {name:'销售管理系统',url:'https://dhtest-mgtdata.dinghanwang.com',icon:require('../assets/img/pindao.png' )  },
        // {name:'竞采官网',url:'http://gwtest.findbidding.cc',icon:require('../assets/img/home.png' )  },
        // {name:'竞采保函系统-客户端',url:'http://bhtest.findbidding.cc/',icon:require('../assets/img/people.png' )  },
        {name:'演示系统',url:'https://caigou.dinghanwang.com/',icon:require('../assets/img/eee.png' )  },
        {name:'演示系统-安责',url:'http://testaz.dinghanwang.com',icon:require('../assets/img/file.png' )  },
        {name:'邮箱登录',url:'https://mail.hwmail.com.cn/mail/',icon:require('../assets/img/mail.png' )  },
        {name:'TAPD项目管理登录',url:'https://www.tapd.cn/my_dashboard',icon:require('../assets/img/lingdang.png' )  },
        {name:'华为云管理登录',url:'https://auth.huaweicloud.com/authui/login.html?id=nmgxykj#/login',icon:require('../assets/img/yun_1.png' )  },
        {name:'定时任务管理系统',url:'https://dhtest-xxljob.dinghanwang.com/xxl-job-admin/toLogin',icon:require('../assets/img/time.png' )  },
        // {name:'elastic日志管理系统',url:'http://elk.dinghanwang.com/',icon:require('../assets/img/huifu.png' )  },
        {name:'nexus中央存储库',url:'http://123.60.65.215:10082/',icon:require('../assets/img/dun.png' )  },
        {name:'datat',url:'http://123.60.65.215:9092/',icon:require('../assets/img/images.png')},
        // {name:'knife4j',url:'http://121.37.86.139:8081/doc.html#/home',icon:require('../assets/img/aite.png')},
        {name:'jenkins',url:'http://jenkins.dinghanwang.com',icon:require('../assets/img/aite.png')},
        {name:'GitLab',url:'https://dhgitlab.dinghanwang.com/users/sign_in',icon:require('../assets/img/aite.png')},
        {name:'rocketMQ',url:'https://dhtest-rocketmq.dinghanwang.com/',icon:require('../assets/img/aite.png')},

      ],
      // 打包时，dev为测试环境，prod为生产包环境，test为新测试环境
    environment:'prod',
    } 
  },
  computed:{
    list(){
      const map = {
        dev: this.linKObjDev,
        prod: this.linKObjProd,
        test: this.linKObjTest
      };
      let list = map[this.environment] || [];
      return list
    }
  },
  methods:{
     readyGo(url) {
      if(url == ''){
       let msg = this.environment=='dev'?'测试环境':'生产环境'
        alert('暂无'+msg +'地址')
        return
      }
      window.open(url,'_blank')
    }
  }
};
</script>
 <style scoped >
 
 .color1{
    background: #2D81FF;
 }
 .color2{
    background: #00BBFF;
 }
 .color3{
    background: #00DDDD;
 }
 .color4{
    background: #00DDAA;
 }
 .color5{
    background: #73df8b;
 }
 .color6{
    background: #7cc642;
 }
.index{
    width: 100%;
    min-height: 100vh;
    max-height: 100vh;
    background-image:url('../assets/img/circle.jpg');
    background-attachment:fixed;
    /* background-repeat:repeat;
   background-size:100% 100%;
    -moz-background-size:100% 100%; */
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
.index-con{
    width: 1400px;
    min-height: 100px;
    /* background: pink; */
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}
.index-con-item{
    width: 335px;
    height: 154px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow:  0 2px 8px rgba(255, 255, 255, 0.5);
    cursor: pointer;
    
}
.index-con-item:hover{
  animation: pulse; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 0.8s; /* don't forget to set a duration! */
}
@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
}

50% {
    -webkit-transform: scale(1.04);
    transform: scale(1.04);
}

100% {
    -webkit-transform: scale(1);
    transform: scale(1);
}
}
.index-con-item img{
  width: 66px;
  height: 66px;
  margin-bottom: 10px;
}
.index-con-item div{
  font-size: 18px;
  color: #fff;
}
@media screen and (max-width: 1800px) {
  .index-con{
    transform: scale(0.8);
    /* margin-top: 20px; */
  }
  .index-con-item{
      width: 285px;
    }
}
@media screen and (max-width: 1500px) {
  .index-con{
    transform: scale(0.6);
    /* margin-top: 20px; */

  }
  .index-con-item{
      width: 285px;
    }
}
@media screen and (max-width: 1300px) {
  .index-con{
    transform: scale(0.6);
    /* margin-top: 20px; */

  }
  .index-con-item{
      width: 285px;
    }
}
@media screen and (max-width: 1200px) {
  .index-con{
    transform: scale(0.5);
    /* margin-top: 20px; */

  }
  .index-con-item{
      width: 235px;
      height: 134px;

    }
}
@media screen and (max-width: 1000px) {
  .index-con{
    transform: scale(0.5);
    /* margin-top: 20px; */

  }
  .index-con-item{
      width: 175px;
      height: 134px;
    }
}



</style>